<template>
  <!-- 客户群发 -->
  <div>
    <div class="f-search-block">
      <div class="search-items">
        <div class="field-item">
          <div class="field-item-label">
            群发标题：
          </div>
          <div class="field-item-control">
            <el-input
              v-model="params.title"
              placeholder="请输入群发标题"
              class="input-m m-r-6"
              clearable
            />
          </div>
        </div>
        <div class="search-btns">
          <el-button
            type="primary"
            @click="searchList"
          >
            查询
          </el-button>
        </div>
      </div>
    </div>

    <div class="f-toolbar-block">
      <el-button
        type="primary"
        @click="goEdit()"
      >
        新建群发
      </el-button>
      <span
        class="tips"
      >管理员新建企业群发后，由添加客户的成员确认后发送给客户或由群主确认后发送给客户群。</span>
    </div>

    <div class="f-table-block">
      <el-table
        v-loading="loading"
        :data="list"
      >
        <el-table-column
          prop="title"
          label="群发标题"
        />
        <el-table-column
          prop="chat_type"
          label="群发类型"
        >
          <template slot-scope="scope">
            <span>发送{{ scope.row.chat_type === 1 ? '客户' : '群' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="text"
          label="群发内容"
        />
        <el-table-column
          prop="sent_at_str"
          label="推送时间"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
        />
        <el-table-column
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.is_delete">
              <div>
                <el-button
                  type="text"
                  @click="goEdit(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="text"
                  @click="deleteList(scope.row)"
                >
                  删除
                </el-button>
              </div>
            </template>
            <el-button
              v-else
              type="text"
              @click="goInfo(scope.row)"
            >
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="table-pagination"
        background
        :current-page="params.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="params.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total_count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      params: {
        title: '',
        page: 1,
        page_size: 20
      },
      list: [],
      total_count: 0,
      loading: false
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 获取列表数据
    async getList () {
      this.loading = true
      const data = await this.$api.membership.getGroupmsgList(this.params).catch(() => {
        this.loading = false
      })
      if (data) {
        this.list = data.list
        this.total_count = data.total_count
        this.loading = false
      }
    },
    // 列表点击切换tab
    handleClick () {
      this.params.page = 1
      this.searchList()
    },

    // 查询列表数据
    searchList () {
      this.params.page = 1
      this.getList()
    },

    // 列表分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    },

    goEdit (item) {
      let id = item ? item.id : 0
      this.$router.push({ path: '/membership/customerGroup/' + id })
    },

    goInfo (item) {
      let id = item ? item.id : 0
      this.$router.push({ path: '/membership/customerGroupInfo/' + id })
    },

    deleteList (item) {
      this.$confirm('此操作将永久删除该群发，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.membership.deleteGroupMsg(item.id).then((response) => {
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
            this.getList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}

.dialog-tips {
  color: #999999;
  font-size: 12px;
  line-height: 24px;
}
.import-body {
  margin-top: -20px;
  .import-content {
    height: auto;
    margin-bottom: 25px;
  }
  .importBtns {
    height: auto;
    position: relative;
  }
  .button-right {
    display: flex;
    align-items: center;
    position: absolute;
    left: 84px;
    top: 0;
    margin: auto;
  }
}
.export-content {
  margin-top: 20px;
}
.tips {
  font-size: 12px;
  color: #9a9097;
  margin-left: 10px;
}
</style>
